import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@/i18n';
import { hydrateTheme } from '@/stores/ui-store';
import './styles/globals.css';

// Apply theme before first paint to avoid FOUC.
hydrateTheme();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
